import { render, staticRenderFns } from "./ComponentList.vue?vue&type=template&id=2b225c4e&scoped=true&"
import script from "./ComponentList.vue?vue&type=script&lang=js&"
export * from "./ComponentList.vue?vue&type=script&lang=js&"
import style0 from "./ComponentList.vue?vue&type=style&index=0&id=2b225c4e&lang=scss&scoped=true&"
import style1 from "./ComponentList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b225c4e",
  null
  
)

export default component.exports